angular.module('memberPortal').directive('addToHomescreenMessage', ["$stateParams", function($stateParams) {
  return {
    restrict: 'EA',
    template: require('templates/member_portal/add_to_homescreen_message.html.slim'),
    controller: ["$scope", "CwStorage", function($scope, CwStorage) {
      $scope.isAndroid = function() {
        return window.navigator.userAgent.indexOf('Android') > -1;
      };
      $scope.isIphone = function() {
        return window.navigator.userAgent.indexOf('iPhone') > -1;
      };
      $scope.isIpad = function() {
        return window.navigator.userAgent.indexOf('iPad') > -1;
      };
      $scope.isIos = function() {
        return $scope.isIphone() || $scope.isIpad();
      };
      $scope.isDisplaying = ($scope.isAndroid() || $scope.isIos()) && !CwStorage.getItem('hideAddToHomeScreenMessage');
      return $scope.hide = function() {
        $scope.isDisplaying = false;
        return CwStorage.setItem('hideAddToHomeScreenMessage', false);
      };
    }]
  };
}]);
